<template>
  <v-container id="data-tables" tag="section" fluid class="pa-0 data-tables">
    <v-card class="pa-3 rounded-lg elevation-0" v-if="searchs.length > 0">
      <v-card-title class="mt-n2">
        <v-row>
          <template  v-for="(search, sidx) in searchs">
            <v-col
              v-if="item.mobile && $isMobile ? search.mobile : true"
              :key="sidx"
              class='px-0 pb-0'
              cols="12"
              :sm='search.type === "input" ? 2 : 2'>
              <div>
                <v-text-field
                  v-if="search.type === 'input'"
                  dense outlined
                  hide-details
                  class="mr-2"
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  :append-icon="search.icon"
                  v-model='search.model'
                  @keydown="queryKeyDown()"
                  :label="search.label" >
                </v-text-field>
              </div>

             <base-material-date
                v-if="search.type === 'date'"
                class="pr-2"
                dense outlined
                hide-details
                clear-icon="mdi-close-circle-outline"
                :append-icon="search.icon"
                :range="search.range"
                :multiple="search.multiple"
                :label='search.label'
                v-model='search.model'
                @on-change="loadData"
              >
              </base-material-date>

              <v-select
                v-if="search.type === 'select'"
                class="mr-2"
                hide-details
                dense outlined
                clearable
                :append-icon="search.icon"
                clear-icon="mdi-close-circle-outline"
                @change="query"
                :items="search.options()"
                v-model="search.model"
                :item-text="search.itemText || 'label'"
                :item-value="search.itemValue || 'value'"
                :multiple="search.multiple"
                :label="search.label">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.label || item.name }}</span>
                  <span
                    v-if="index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ search.model.length - 1 }} 个其他)
                  </span>
                </template>
              </v-select>

            </v-col>
          </template>
          <slot name='condition'></slot>
          <div class="mt-3">
            <template  v-for="(btns, bidx) in item.topButtons">
              <v-btn :key="bidx" color="primary" :small='$isMobile' :loading="loading"  v-if="btns.event === 'search' && btns.show" class="mr-1 px-2"  @click='query' depressed>
                <v-icon>mdi-magnify</v-icon>
                查询
              </v-btn>
              <v-btn :key="bidx" color="success" :small='$isMobile' v-if="btns.event === 'add' && btns.show" class="mr-1 px-2"  @click='add' depressed>
                <v-icon>mdi-plus</v-icon>
                添加
              </v-btn>
              <download-excel
                :key="bidx"
                style='float: right;'
                v-if="btns.event === 'download' && btns.show && !$isMobile"
                :fetch= "download"
                :header='excel.header'
                :fields="excel.fields"
                :name="excel.filename" >
                <v-btn :loading="downloading" color="secondary"  class="mr-1 px-2" depressed>
                  <v-icon>mdi-download-circle-outline</v-icon>
                  下载
                </v-btn>
              </download-excel>
            </template>
            <slot name='actions'></slot>
          </div>
        </v-row>
      </v-card-title>
    </v-card>

    <div class="my-3">
      <slot name='head'></slot>
    </div>

    <div class="my-3">
      <v-data-table
        v-if="!item.mobile || !$isMobile"
        calculate-widths
        :headers="headers"
        :page.sync="page.current"
        :items="columns"
        @update:sort-by="sortBy"
        @update:sort-desc="sortDesc"
        @item-selected='itemSelect'
        @toggle-select-all='itemSelectAll'
        :items-per-page="page.size"
        :server-items-length="page.total"
        hide-default-footer
        class="elevation-0 rounded-lg"
        :loading='loading'
        loading-text="加载中... 请稍等"
        no-data-text="暂时没有数据"
        v-bind='$attrs'
        :expanded="expanded"
        v-model="selected"
      >

        <template v-for="(header, hidx) in headers" v-slot:top >

          <div :key="hidx" v-if="header.hasOwnProperty('query')"> {{header}}</div>

        </template>

        <template
          v-for="(head, hidx) in headers"
          v-slot:[`item.${head.value}`]='{ header, value, item }'
          >

          <div :key="hidx" v-if="header.hasOwnProperty('formatter')">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <span v-bind="attrs" v-on="on">
                  <v-icon @click="copy(header.formatter(value, item))" style="float: right;" size="19" v-if="header.hasOwnProperty('copy')">mdi-file-check-outline</v-icon>
                  {{header.formatter(value, item) | cutLongStr}}
                </span>
              </template>
              <span>{{header.formatter(value, item)}}</span>
            </v-tooltip>
          </div>

          <div :key="`select-${hidx}`" v-else-if="header.hasOwnProperty('select')">
            <v-select
              :items="header.select.options()"
              label=""
              return-object
              @change='header.select.onChange(item, $event)'
              :item-text="header.select.itemText || 'label'"
              :item-value="header.select.itemValue || 'value'"
              v-model='header.select.value(value)'
              :disabled="header.select.disabled(item)"
              hide-details
              filled rounded single-line dense
            >
              <template v-slot:selection="{ item }">
                <span :class="`${header.select.color(value)}--text`">{{item.name}}</span>
              </template>
            </v-select>
          </div>

          <div :key="`switch-${hidx}`"  v-else-if="header.hasOwnProperty('switch')">
            <v-switch
              class="mt-0"
              hide-details
              true-value
              v-model='header.switch.value(value)'
              :label='header.switch.label(value)'
              @change='header.switch.onClick(item)'>
            </v-switch>
          </div>

          <div :key="`chip-${hidx}`"  v-else-if="header.hasOwnProperty('chip')">
            <v-chip :color='header.chip.color(value)' class="px-2" label dark small>
              {{header.chip.formatter(value, item) }}
            </v-chip>
          </div>

          <div :key="`span-${hidx}`"  v-else-if="header.hasOwnProperty('span')">
            <span :class="`${header.span.color(value, item)}--text`">
              {{header.span.formatter(value, item) }}
            </span>
          </div>

          <div :key="`icon-${hidx}`"  v-else-if="header.hasOwnProperty('icon')">

            <v-icon :color='header.icon.color' v-if="header.icon.onClick" @click='header.icon.onClick(item)'>
              {{header.icon.value}}
            </v-icon>

            <v-tooltip top v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon :color='header.icon.color'>
                   {{header.icon.value}}
                  </v-icon>
                </v-btn>
              </template>
              <span></span>
            </v-tooltip>
          </div>

          <div :key="`avatar-${hidx}`"  v-else-if="header.hasOwnProperty('avatar')">
            <v-avatar size="36">
                <img
                  v-if="header.avatar(value)"
                  :src="header.avatar(value)"
                >
                <v-img v-else :src="require('@/assets/def-head.jpeg')" />
            </v-avatar>
          </div>

          <div :key="`image-${hidx}`"  v-else-if="header.hasOwnProperty('image')">
            <img
                  v-if="header.image.src(value)"
                  :src="header.image.src(value)"
                  :width="header.image.width"
                  :height="header.image.height"
                  contain
                >
              <span v-else>--</span>
          </div>

          <div :key="`else-${hidx}`"  v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <span v-bind="attrs" v-on="on">
                  <v-icon @click="copy(value)" style="float: right;" size="19" v-if="header.hasOwnProperty('copy')">mdi-file-check-outline</v-icon>
                  <div>{{value | cutLongStr}}</div>
                </span>
              </template>
              <span>{{value}}</span>
            </v-tooltip>
          </div>


          <template v-if="header.hasOwnProperty('actions')" v-for="btns in header.actions">

              <v-tooltip bottom v-if="btns.hasOwnProperty('onClick') !== -1">
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      v-if='!btns.disable(item)'
                      depressed
                      dark
                      text
                      :color="btns.color"
                      @click='btns.onClick(item, btns)'
                      class="px-c-3">
                    <!-- <v-icon size="20" class="mr-1" dark>{{btns.icon}}</v-icon> -->{{btns.text || btns.dtext(item)}}
                  </v-btn>
                </template>
                <span>{{btns.text}}</span>
              </v-tooltip>

          </template>

          <template v-if="header.hasOwnProperty('menu')">
            <!-- <v-speed-dial direction="left">
              <template v-slot:activator>
                <v-btn
                  :color="header.menu.color"
                  dark
                  small
                  text
                  class="px-1"
                >
                  <v-icon size="18" class="mr-1" dark>{{header.menu.icon}}</v-icon>
                  {{header.menu.text}}
                </v-btn>
              </template>
              <v-btn
                  v-for="(btns, index) in header.menu.actions"
                  :key="index"
                  small
                  dark
                  class="px-2"
                  :color="btns.color"
                  @click='btns.onClick(item, btns)'
                  v-if='!btns.disable(item)'
                >
                <v-icon size="17"  class="mr-1">{{btns.icon}}</v-icon>{{ btns.text || btns.dtext(item) }}
              </v-btn>
            </v-speed-dial> -->
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="header.menu.color"
                  dark
                  small
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="18" class="mr-1" dark>{{header.menu.icon}}</v-icon>
                  {{header.menu.text}}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  link
                  v-for="(btns, index) in header.menu.actions"
                  :key="index"
                  @click='btns.onClick(item, btns)'
                  v-if='!btns.disable(item)'
                >
                  <v-list-item-title class='size-14'>
                    <v-icon size="20" :color="btns.color" class="mr-1">{{btns.icon}}</v-icon>{{ btns.text || btns.dtext(item) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <slot name='expanded-content' :item="item" :headers='headers' :refresh='refreshMore'></slot>
        </template>

        <template v-slot:foot>
          <slot name='foot' :loading="totaloanding" :total="totalDtata"></slot>
        </template>

      </v-data-table>

      <!--手机端显示-->
      <div v-else>
        <div class="white rounded-lg mb-2">
          <slot name='foot' :loading="totaloanding" :total="totalDtata"></slot>
        </div>

        <v-card class="rounded-lg elevation-0 mb-3" v-for="(column, idx) in columns" :key="idx">

          <v-card-title v-if="mobileShowSelect" class="py-1">
            <v-checkbox :id='`id-${idx}`' dense multiple v-model="selected" @change="mobileItemSelect" :value="column"></v-checkbox>
          </v-card-title>

          <v-card-subtitle  v-for="(header, index) in headers.filter(obj => obj.mobile)" :key="index" :class="index === 0 || index === headers.length-1 ? 'py-2' : index+1 === headers.filter(obj => obj.mobile).length ? 'py-1' : 'py-0'">
            <div v-if="index <= showMinColumn">
              <mobile-table :header="header" :column="column" :index='idx'/>
            </div>

            <v-card-actions v-if="header.hasOwnProperty('actions')" class='pa-0 my-3'>
              <v-btn
                color="grey"
                @click="showMobileMore(idx)"
                text
                x-small
                class="pl-0">
                <v-icon size="17">{{ idx === showMobileIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showMobileIdx ? '折叠' : '更多' }}
              </v-btn>
              <v-spacer></v-spacer>
              <div v-for="(btns, btnidx) in header.actions" :key="btnidx">
                <div v-if="btns.hasOwnProperty('onClick') !== -1">
                  <v-btn
                    x-small
                    v-if='!btns.disable(column)'
                    depressed
                    dark
                    text
                    :color="btns.color"
                    @click='btns.onClick(column, btns)'
                    class="pr-0">{{btns.text}}
                  </v-btn>
                </div>
              </div>
            </v-card-actions>

            <v-card-actions v-else-if="header.hasOwnProperty('menu')" class='pa-0 my-3'>
              <v-btn
                color="grey"
                @click="showMobileMore(idx)"
                text
                x-small
                class="pl-0">
                <v-icon size="17">{{ idx === showMobileIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showMobileIdx ? '折叠' : '更多' }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-menu offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="header.menu.color"
                    dark
                    x-small
                    text
                    v-bind="attrs"
                    v-on="on"
                    >
                    <v-icon size="20" class="mr-1" dark>{{header.menu.icon}}</v-icon>
                    {{header.menu.text}}
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    link
                    v-for="(btns, index) in header.menu.actions"
                    :key="index"
                    @click='btns.onClick(column, btns)'
                    v-if='!btns.disable(column)'
                    class="px-3"
                    >
                    <v-list-item-title class='size-14'>
                      <v-icon size="17" :color="btns.color" class="mr-1 mb-c-2">{{btns.icon}}</v-icon>
                      <span class="grey--text text--darken-3 size-12">{{ btns.text || btns.dtext(item) }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-actions>

            <v-expand-transition>
              <div>
                <div v-show="idx === showMobileIdx && index > showMinColumn">
                  <mobile-table :header="header" :column="column"/>
                </div>
                <v-card-actions
                  class='pa-0 my-3'
                  v-if="
                  headers.filter(obj => obj.mobile).length > showMinColumn
                  && headers.filter(obj => obj.mobile).length === index +1
                  && !header.hasOwnProperty('menu')
                  && !header.hasOwnProperty('actions')
                  "
                  >
                  <v-btn
                    color="grey"
                    @click="showMobileMore(idx)"
                    text
                    x-small
                    class="pl-0">
                    <v-icon size="17">{{ idx === showMobileIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showMobileIdx ? '折叠' : '更多' }}
                  </v-btn>
                </v-card-actions>
              </div>
            </v-expand-transition>
          </v-card-subtitle>
          <v-expand-transition>
            <div v-if="idx === showIdx">
              <slot name='expanded-content' :item="column" :headers='headers' :refresh='refreshMore'></slot>
            </div>
          </v-expand-transition>
        </v-card>
      </div>

      <div class="white pa-6 my-3 rounded-lg">
        <div class="mt-n2 float-left">
          <v-text-field
            outlined
            dense
            style="width:170px;height:30px"
            hide-details
            v-model="skipPage"
            @keydown="queryKeyDown()"
            type="number"
            prefix="跳转至["
            suffix="]页"
          ></v-text-field>
        </div>
        <v-row align="center" justify="end">
          <div class="grey--text">共 {{page.total}} 条</div>
          <v-pagination
            class="grey--text"
            justify="space-around"
            :total-visible="7"
            v-model="page.current"
            :length="page.count"
            @input="nextPage"
          ></v-pagination>
        </v-row>
      </div>
   </div>
   <v-dialog v-model="delDialog" max-width="320">
     <v-card>
       <v-card-title class="text-h6">
         <v-icon color="warning">mdi-alert</v-icon>&nbsp;
         系统提示
       </v-card-title>
       <v-card-text>
         <div class="text-h6 pa-2">确定执行{{delBtnText}}操作吗？</div>
       </v-card-text>
       <v-card-actions class="justify-end p4-1">
         <v-btn text small color="blue" @click="delDialog = false">取消</v-btn>
         <v-btn color="primary" :loading="deleteLoading" depressed small @click="deleted">
           确定
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>
   <v-overlay :value="loading && $isMobile">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
  import { list, remove, total } from '@/api/data.js'
  import {
    toHump,
    isEmpty,
    cutString,
    isNumber
  } from '@/utils/stringUtil.js'

  import MobileTable from './MobileTable.vue'

  export default {
    name: 'MaterialTables',
    components: {
      MobileTable
    },
    filters: {
      cutLongStr (val) {
        if (isNumber(val)) {
          return val
        } else if (!isEmpty(val)) {
          return cutString(val, 20)
        }
        return ''
      }
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          mobile: false,
          path: '',
          total: false,
          headers: [],
          topButtons: [],
          sort: null,
          singleSelect: true
        })
      },
      mobileShowSelect: {
        type: Boolean,
        default: false
      },
      rowClick: {
        type: Boolean,
        default: false
      },
      excel: {
        type: Object,
        default: () => ({
          path: null,
          header: '',
          fields: {},
          filename: '文件下载.xls'
        })
      }
    },
    data () {
      return {
        row: {},
        delDialog: false,
        delBtnText: '',
        deleteLoading: false,
        downloading: false,
        loading: false,
        totaloanding: false,
        formParams: {},
        date: undefined,
        skipPage: '',
        columns: [],
        expanded: [],
        selected: [],
        mobileSelected: [],
        showSnackbar: true,
        totalDtata: {},
        refreshMore: false,
        showIdx: -1,
        showMobileIdx: -1,
        showMinColumn: 3,
        page: {
          total: 0,
          count: 0,
          size: 10,
          current: 1,
          orderByField: 'id',
          asc: false
        }
      }
    },
    created() {
      if (!isEmpty(this.item.sort)) {
        this.page.orderByField = this.item.sort.orderByField
        this.page.asc = this.item.sort.asc || false
      }
      this.loadData()
    },
    methods: {
      showMore (item, idx) {
        if (this.item.mobile && this.$isMobile) {
          this.showIdx = this.showIdx === idx ? -1 : idx
          this.expanded = this.showIdx !== -1
        } else {
          this.expanded = item === this.expanded[0] ? [] : [item]
        }
      },
      showMobileMore(idx) {
        this.showMobileIdx = this.showMobileIdx === idx ? -1 : idx
      },
      nextPage (current) {
        this.page.current = current
        this.loadData()
      },
      doDelete (item, btn) {
        this.delDialog = true
        this.row = item
        this.delBtnText = btn.text
      },
      itemSelect (item) {
        if (item.value) { // 选中
          this.selected.push(item.item)
        } else {
          this.selected.splice(this.selected.indexOf(this.selected.find((element) => element.id === item.item.id)), 1)
        }
        this.$emit('input', this.selected)
      },
      itemSelectAll (item) {
        this.$emit('input', item.value ? item.items : [])
      },
      mobileItemSelect () {
        this.$emit('input', this.selected)
      },
      resetSelect () {
        this.selected = []
        this.$emit('input', this.selected)
      },
      deleted () {
        this.deleteLoading = true
        remove(this.item.path.replace('list', 'delete'), this.row.id).then(res => {
          if (res.status === 200) {
            this.delDialog = false
            this.loadData()
            this.$emit("on-delete-success")
            this.$dialog.notify.success('数据操作成功！', { position: 'top-right', timeout: 3000 })
          }
          this.deleteLoading = false
        })
      },
      edit (item) {
        this.$emit('on-edit', item)
      },
      add () {
        this.$emit('on-add')
      },
      copy (val) {
        // 动态创建 textarea 标签
        const textarea = document.createElement('textarea');
        // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
        textarea.readOnly = 'readonly';
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        // 将要 copy 的值赋给 textarea 标签的 value 属性
        textarea.value = val;
        // 将 textarea 插入到 body 中
        document.body.appendChild(textarea);
        // 选中值并复制
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        const result = document.execCommand('Copy');
        if (result) {
          this.$dialog.notify.info('复制成功！', { position: 'bottom-right' })
        }
        document.body.removeChild(textarea);
      },
      async download () {
        let data = []
        this.downloading = true
        await list(this.excel.path || this.item.path, Object.assign(this.getFormParams(), this.item.params)).then(res => {
          if (res.status === 200) {
            data = this.excel.path ? res.data : res.data.records
          }
        })
        this.downloading = false
        return data
      },
      detail (item) {
        this.$emit('on-detail', item)
      },
      sortBy (field) {
        this.page.orderByField = this.orderBy[field[0]] || 'id'
      },
      sortDesc (sort) {
        this.page.asc = sort[0] === 'undefined' ? false : sort[0]
        this.loadData()
      },
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.page.current = Number(this.skipPage) || 1
          this.loadData()
        }
      },
      query () {
        this.page.current = 1
        this.loadData()
      },
      getFormParams () {
        const this_ = this
        this.searchs.forEach((sech) => {
          const key = sech.secKey
          this_.formParams[key] = sech.model
        })
        return this.formParams
      },
      loadData () {
        this.showIdx = -1
        this.showMobileIdx = -1
        this.resetSelect()
        this.loading = true
        Object.assign(this.pageParams, this.getFormParams(), this.item.params)
        list(this.item.path, this.pageParams).then(res => {
          this.loading = false
          if (res.status === 200) {
            this.page.count = res.data.pages
            this.page.current = res.data.current
            this.page.total = res.data.total
            this.columns = res.data.records
          }
        })
        this.totalData()
      },
      totalData () {
        this.totalDtata = {}
        if (this.item.total) {
          this.totaloanding = true
          Object.assign(this.getFormParams(), this.item.params)
          total(this.item.path.replace('list', 'total'), this.getFormParams()).then(res => {
            if (res.status === 200) {
              this.totalDtata = res.data
            }
            this.totaloanding = false
          })
        }
      },
      peachWord(word) {
        return word.replace(/([A-Z])/g, "_$1").toLowerCase()
      },
      btnCallback(ddd) {
        console.log(ddd)
      }
    },
    computed: {
      pageParams () {
        return {
          page: {
            current: this.page.current,
            size: this.page.size,
            orderByField: this.peachWord(this.page.orderByField),
            asc: this.page.asc
          }
        }
      },
      headers () {
        const headers = []
        this.item.headers.forEach((head) => {
          if (!head.hidden) {
            headers.push(head)
          }
        })
        return headers
      },
      searchs () {
        const searchs = []
        this.item.headers.forEach((head) => {
          const sech = {}
          if (head.search) {
            sech.label = head.search.label || head.text
            sech.type = head.search.type
            sech.mobile = head.search.mobile
            sech.model = head.search.multiple ? head.search.model || [] : head.search.model || ''
            sech.secKey = head.search.secKey || toHump(head.value.replace('.', '_'))
            sech.icon = head.search.icon || ''
            sech.options = head.search.options
            sech.itemText = head.search.itemText
            sech.itemValue = head.search.itemValue
            sech.multiple = head.search.multiple || false
            sech.range = head.search.range || false
            searchs.push(sech)
          }
        })
        return searchs
      },
      orderBy () {
        const orders = {}
        this.item.headers.forEach((head) => {
          if (head.sortable || !head.hasOwnProperty("sortable")) {
            const key = head.value
            orders[key] = head.sortKey || head.value
          }
        })
        return orders
      }
    },
    watch: {
      expanded () {
        this.refreshMore = false
          this.$nextTick(() => {
          this.refreshMore = true
        })
      }
    }
  }
</script>
